module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '' && _vm.subpage == 'open') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Felhívás, formai kritériumok")]), _vm._v(" "), _c('PerfectScrollbar', {
    staticStyle: {
      "height": "50vh",
      "border": "1px solid #f4f4f4",
      "padding": "20px 20px 0px 20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "options": {
        wheelPropagation: false,
        handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']
      }
    }
  }, [_c('div', {
    staticClass: "article-text medium"
  }, [_c('p', [_vm._v("Tisztelt Ösztöndíjasok!")]), _vm._v(" "), _c('p', [_vm._v("A Széchenyi István Egyetem az Új Nemzeti Kiválóság Program keretein belül 2021/2022-es tanévben ötödik alkalommal, ISSN számmal ellátott magyar nyelvű kiadványt jelentet meg az Ösztöndíjasok kutatási eredményeiről. A Tanulmánykötetben való publikálás az első közlés helye*, az "), _c('u', [_vm._v("ÚNKP Ösztöndíjasok számára kötelező")]), _vm._v(", azt a szakmai záró beszámolóban fel kell tüntetni. Egyéni kérésre, további felhasználás céljából (más ösztöndíjpályázathoz, stb.) a Tanulmánykötetben való publikálásról a kötet megjelenése utáni fél évig igazolást állítunk ki. Az MTMT adatbázisba való feltöltéshez az egyetemi könyvtárban kérhető segítség.")]), _vm._v(" "), _c('p', [_vm._v("A következő "), _c('strong', [_vm._v("formai kritériumok")]), _vm._v(" szerint kérjük leadni az anyagokat:")]), _vm._v(" "), _c('ul', {
    staticClass: "ordered-list with-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Terjedelem: "), _c('strong', [_c('u', [_vm._v("MAXIMUM 8+1 oldal a forrásjegyzékkel együtt")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("20 000 n, azaz leütés szóközökkel, egy "), _c('strong', [_c('u', [_vm._v("B5-ös méretű")])]), _vm._v(" kiadványban")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_c('u', [_vm._v("11 pt, Times New Roman betűtípus")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_c('u', [_vm._v("szimpla sorköz")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('strong', [_c('u', [_vm._v("margó minden oldalon 2,5-ös")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Kérjük, a szövegek csak a címek számozásával, de formázás nélkül legyenek leadva, és a törzsszövegben is csak a legfontosabb formázások legyenek")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Az esetleges ábrákat, fotókat a szövegbe illesztve, illetve külön is fel lehet majd tölteni a KTR felületre")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A közvetlen hivatkozások lábjegyzetekben, az oldal alján legyenek feltüntetve")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A szerző neve (nyomtatott nagybetűvel) után legyen megadva 1-es számú lábjegyzetben, hogy az Egyetemen melyik képzésen/Tanszéken (Doktori Iskola/Kar) tanul, oktat. Ugyanebben a lábjegyzetben mindenképpen kerüljön feltüntetésre a Témavezető neve, beosztása, szervezeti egysége – Kar és Tanszék")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Hallgatóknál:")]), _vm._v(" SZE képzés, Szak. Témavezető: neve, beosztása, SZE Kar, Tanszék.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Munkatársaknál:")]), _vm._v(" SZE Kar/Doktori Iskola, Tanszék, beosztás. Témavezető, mint hallgatóknál, ahol releváns. A lábjegyzetek számozását innen kell folytatni.")]), _vm._v(" "), _c('p', [_vm._v("Példa:")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Szerzői adat a tanulmány elején:")])]), _vm._v(" "), _c('p', [_vm._v("MOLNÁR LEVENTE "), _c('sup', [_vm._v("1")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Lábjegyzet az oldal alján:")])]), _vm._v(" "), _c('p', [_c('sup', [_vm._v("1")]), _vm._v(" SZE egységes, osztatlan képzés, Zenetanár-Gitártanár. Témavezető: Dr. Arnóth Balázs, egyetemi docens, SZE Művészeti Kar, Szólóhangszerek és Művészetelmélet Tanszék")]), _vm._v(" "), _c('p', [_vm._v("A lábjegyzetekre nézve a következők betartása fontos:")]), _vm._v(" "), _c('p', [_vm._v("A közvetlen hivatkozásokat lábjegyzetekben, az oldal alján kérjük feltüntetni. A lábjegyzetben és a forrásjegyzékben szereplő hivatkozások rendje a következő: ")]), _vm._v(" "), _c('p', [_vm._v("Szerző: "), _c('em', [_vm._v("Cím")]), _vm._v(", évszám, kiadó, kiadás helye, oldalszám. Kérjük, hogy mindenhol vesszőt (és nem pontot) alkalmazzanak a bibliográfiai adatok között. Első alkalommal a szerző/k nevét kiskapitálissal, teljes egészében ki kell írni, külföldiek esetében a vezetéknév kerül előre, majd vesszővel elválasztva a keresztnév. Ha háromnál több szerző van, csak a szerkesztőt kell megjelölni a (szerk.) jelzéssel. A mű címe és alcíme dőlt betűtípussal szerepeljen. Ha van alcím, akkor azt a rendes címtől ponttal szükséges elválasztani, egyébként csak a bibliográfiai hivatkozás legvégén van pont.")]), _vm._v(" "), _c('p', [_vm._v("Amennyiben folyóiratból, gyűjteményes kötetből származik a forrás, úgy a mű címe után vessző következik, majd az „in” szócska (ami kisbetűvel, kettőspont nélkül szerepel) és a folyóirat vagy gyűjteményes kötet adatai. Utóbbinak rendszerint van szerkesztője, így azt is fel kell tüntetni.")]), _vm._v(" "), _c('p', [_vm._v("Folyóirat esetén a szám az alábbi formában legyen megjelölve: évszám/sorszám. „szám”.pl. …, in "), _c('i', [_vm._v("Magyar Jog")]), _vm._v(", 2006/7. szám, 34. o. Ezekben az esetekben nem a közvetlen forrás, hanem a folyóirat vagy gyűjteményes mű címe szerepel dőlt betűvel. Az oldalszámot kis „o” betű jelöli. Internetes forrás esetén a letöltés helyét és idejét fel kell tüntetni")]), _vm._v(" "), _c('p', [_vm._v("Példák:")]), _vm._v(" "), _c('ul', {
    staticClass: "ordered-list with-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("1 ")]), _vm._v("Csécsy György: "), _c('em', [_vm._v("Védjegyjog és piacgazdaság")]), _vm._v(", 2001, Novotni kiadó, Miskolc, 36. o.\n  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("2 ")]), _vm._v("Szladits Károly - Zakkaria, Fareed - Mezey Barna (szerk.): \n  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("3 ")]), _vm._v("Bíró György: Átruházó szerződések, in "), _c('em', [_vm._v("Polgári Jogi Kodifikáció")]), _vm._v(", 2003/2. szám, 14–30. o.\n  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("4 ")]), _vm._v("Eörsi Gyula: A tulajdonátszállás kérdéseiről, in Sárközy Tamás – Vékás Lajos (szerk.): "), _c('em', [_vm._v("Eörsi Gyula emlékkönyv")]), _vm._v(", 2002, HVG-ORAC Lap-és Könyvkiadó Kft., Budapest, 277–420. o.\n  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("5 ")]), _vm._v("Menyhárd Attila: A tulajdonjog tárgyai, előadás a "), _c('em', [_vm._v("Symposium Iubilaei Facultatis Iaurinensis")]), _vm._v(" című konferencián, 2010. szeptember 21., Széchenyi István Egyetem Deák Ferenc Állam-és Jogtudományi Kar.\n  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("6 ")]), _vm._v("Csiky Péter: A TRIPS egyezmény szerepe a nemzetközi iparjogvédelmi rendszerben, in "), _c('em', [_vm._v("Iparjogvédelmi és Szerzői Jogi Szemle")]), _vm._v(", 1998/3. szám, http://www.mszh.hu/kiadv/ipsz/199806/csiki.html, 2010. március 14.\n  ")])]), _vm._v(" "), _c('p', [_vm._v("Egy mű ismételt hivatkozása esetén a Szerző vezetékneve valamint az „i. m.” megjelölés és az oldalszám szerepel. Ha ugyanannak a szerzőnek több műve is szerepel a hivatkozások között, az „i. m.” után zárójelben az érintett mű évszámát is fel kell tüntetni. Egymást követő lábjegyzetekben, ugyanarra a műre történő hivatkozás esetén pedig az „Uo.” és oldalszám jelölést kérjük alkalmazni.")]), _vm._v(" "), _c('ul', {
    staticClass: "ordered-list with-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("7 ")]), _vm._v("Eörsi: i. m. 298. o.\n  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), _c('sup', [_vm._v("8 ")]), _vm._v("Uo. 332. o.\n  ")])]), _vm._v(" "), _c('p', [_vm._v("Fontos, hogy a fenti követelmények teljesüljenek minden beadott anyagok esetében, nagymértékben megkönnyítve így a hatékony munkafolyamatot.")]), _vm._v(" "), _c('p', [_vm._v("Üdvözlettel:"), _c('em', [_vm._v(" ÚNKP felelősök")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "1.3em"
    }
  }, [_vm._v("* A Tanulmánykötetben megjelent cikk publikálása másik kötetben, szakfolyóiratban csak másod- (harmad-, stb.) közlésként lehetséges, akkor is, ha az új címmel, új bevezetéssel jelenik meg, de a szöveg kevesebb, mint 10%-a lett átírva. Az új cikkben kell elhelyezni egy lábjegyzetet, amely utal a másod közlésre: \"Az Innovációs és Technológia Minisztérium ÚNKP-21-… ("), _c('i', [_vm._v("saját ÚNKP kódszámra átírva")]), _vm._v(") kódszámú Új Nemzeti Kiválóság Programjának támogatásával készült, "), _c('i', [_vm._v("„eredeti cikk címe”")]), _vm._v(" c. tanulmány átdolgozott verziója e cikk. Az eredeti tanulmány megjelenésének helye: Új Nemzeti Kiválóság Program 2021/2022 Tanulmánykötet. Széchenyi István Egyetem, Győr, 2022., ISSN 2630-8134, 168-179. ("), _c('i', [_vm._v("oldalszámok")]), _vm._v(")\". Plagizálás teljes kizárása érdekében érdemes felkeresni a könyvtári kollégákat, és segítséget kérni az ön-ellenőrzés kapcsán a "), _c('strong', [_vm._v("Turnitin")]), _vm._v(" rendszer segítségével. Ennek módját a következő könyvtári útmutató részletezi. "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://lib.sze.hu/images/Turnitin%20%C3%BAtmutat%C3%B3.pdf",
      "title": ""
    }
  }, [_vm._v("https://lib.sze.hu/images/Turnitin%20%C3%BAtmutat%C3%B3.pdf")])])])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.subpage = 'data'
      }
    }
  }, [_vm._v("Tovább")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.fill_info == '' && _vm.subpage == 'data') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "mobilszam",
      "label": "Mobilszám",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+",
      "name": "mobilszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.mobilszam),
      callback: function($$v) {
        _vm.form.mobilszam = $$v
      },
      expression: "form.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "palyazati_azonosito",
      "label": "Pályázati azonosító <span style='font-size: 10px; display: block; font-weight: 400'>(Az egyedi azonosító számot a pályázat befogadásáról szóló értesítő e-mail-ben kapta meg)</span>",
      "name": "palyazati_azonosito",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.palyazati_azonosito),
      callback: function($$v) {
        _vm.form.palyazati_azonosito = $$v
      },
      expression: "form.palyazati_azonosito"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "tanulmanykotet_dokumentum",
      "label": "ÚNKP tanulmány <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP tanulmány legyen. Pl. Györgyné_Kékesi_Ilona_ÚNKP_tanulmány)</span>",
      "name": "tanulmanykotet_dokumentum",
      "loaded_files": _vm.form.tanulmanykotet_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.form.tanulmanykotet_dokumentum = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "10",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "dokumentumok",
      "label": "Ábrák / képek",
      "name": "dokumentumok",
      "loaded_files": _vm.form.dokumentumok
    },
    on: {
      "change": function (value) {
        _vm.form.dokumentumok = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.form.dokumentum_urlek), function(url, i) {
    return _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "margin-bottom": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.dokumentum_urlek[i]),
        expression: "form.dokumentum_urlek[i]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
      },
      domProps: {
        "value": (_vm.form.dokumentum_urlek[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.form.dokumentum_urlek,
            $$idx = i;
          if (!Array.isArray($$exp)) {
            _vm.form.dokumentum_urlek[i] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button only-icon v2",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "href": _vm.form.dokumentum_urlek[i],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "button only-icon",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteUrl(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_dokumentum_url),
      expression: "uj_dokumentum_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
    },
    domProps: {
      "value": (_vm.uj_dokumentum_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uj_dokumentum_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button only-icon v2",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDocumentUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(2)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP-21 Tanulmánykötet")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Adatok")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3804987f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/unkp_tanulmanykotet_21.vue
// module id = 359
// module chunks = 0